(function ($) {
  Drupal.behaviors.product_brief_bfeed = {
    attach: function (context, settings) {

      // quickshop on aerin mpp
      if(page_data.list_bs_prods !== undefined){
        var qsData = page_data.list_bs_prods.products;
        var $btn_quickshop = $('.button__quickshop', context);
        $btn_quickshop.off('click').on('click', function(e) {
          e.preventDefault();
          var quickshopPID = $(this).attr('data-productid');
          var quickshopData = _.find(qsData, function(p){ return p.PRODUCT_ID == quickshopPID; });
          site.quickshop(quickshopData);
        });
      }

    }// attach
  };
})(jQuery);
